"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            latestCourses: [],
            latestPrograms: []
        };
    },
    onMount: function () {
        this.fetchLatestCourses();
        this.fetchLatestPrograms();
    },
    fetchLatestCourses: async function () {
        try {
            const {error, message, results} = await Request('/learner/course/latest/list?limit=4');
            if (error)
                console.log('Error Fetching Latest Courses: ', message);
            this.state.latestCourses = results || [];
        } catch (error) {
            console.log('Error Fetching Latest Courses');
        }
    },
    fetchLatestPrograms: async function () {
        try {
            const {error, message, results} = await Request('/learner/program/latest/list?limit=4');
            if (error)
                console.log('Error Fetching Latest Programs: ', message);
            this.state.latestPrograms = results || [];
        } catch (error) {
            console.log('Error Fetching Latest Programs');
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Dashboard/Learner/components/Latest.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Card_CourseInsight_template = require("../../../../components/Card-CourseInsight.marko"),
    Card_CourseInsight_tag = marko_loadTag(Card_CourseInsight_template),
    Card_ProgramInsight_template = require("../../../../components/Card-ProgramInsight.marko"),
    Card_ProgramInsight_tag = marko_loadTag(Card_ProgramInsight_template),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    WSAdapt_template = require("../../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_attrs0 = {
        "class": "mx-1 my-2",
        id: "latest-courses"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("section", marko_attrs0, "0", component);

  out.be("h6", null, "1", component);

  Locale_tag({
      text: "Latest"
    }, out, __component, "2");

  out.ee();

  Row_tag({
      renderBody: function(out) {
        if (state.latestCourses.length || state.latestPrograms.length) {
          Row_tag({
              class: "m-0 col p-0",
              renderBody: function(out) {
                var $for$0 = 0;

                marko_forOf(state.latestCourses, function(course) {
                  var $keyScope$0 = "[" + (($for$0++) + "]");

                  Card_CourseInsight_tag(course, out, __component, "5" + $keyScope$0);
                });

                var $for$1 = 0;

                marko_forOf(state.latestPrograms, function(program) {
                  var $keyScope$1 = "[" + (($for$1++) + "]");

                  Card_ProgramInsight_tag(program, out, __component, "6" + $keyScope$1);
                });
              }
            }, out, __component, "4");
        }

        WSAdapt_tag({
            id: "high-alert",
            ns: "col-lg-3 col-md-4 col-sm-12",
            qs: "col-lg-4",
            hs: "d-none"
          }, out, __component, "7");
      }
    }, out, __component, "3");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
